import React from 'react'
import backArrow from '../images/arrow_back.png'

const PlayerModal = ({player, isUsersModal, setSelectedUser, closeModal, hasOverlay}) => {
  return (
    <div className="modal">
      {hasOverlay ?  <div className="modal__overlay" onClick={closeModal}/> : null}
      <div className="modal__content content">
        <div className={`modal__controllers ${!isUsersModal ? 'modal__controllers--solo' : ''}`}>
          {isUsersModal && <button className='modal__back' onClick={() => setSelectedUser(null)}>
            <img src={backArrow} alt=""/>
          </button>}
          <button className="modal__close modal__close--player" onClick={closeModal}>Х</button>
        </div>
        <div className="modal-player">
          <div className="modal-player__card">
            <div className={'card-player'}
                 onClick={() => setSelectedUser(player)}
                 key={player.id}>
              <div className="card-player__image">
                <picture>
                  <source
                    srcSet={
                      `
                    ${player.players.avatar.sourceUrl}  1x,
                    ${player.players.avatar1.sourceUrl}  2x
                    `
                    }
                    type="image/jpeg"
                  />
                  <img src={player.players.avatar.sourceUrl} alt=""/>
                </picture>
                <div className="card-player__number">
                  {player.players.numberplayer}
                </div>
                <div className="card-player__club-logo">
                  <img src={player.players.iconfootbool.sourceUrl} alt=""/>
                </div>
                <div className="card-player__lastName">
                  {player.players.lastname}
                </div>
                <div className="card-player__age">
                  {player.players.agecart}
                </div>
              </div>
            </div>
          </div>
          <div className="modal-player__info">
            <div className="modal-player__title">
              {player.title}
            </div>
            <div className="modal-player__content" dangerouslySetInnerHTML={{__html: player.content}}/>
          </div>

        </div>
      </div>
    </div>
  )
}

export default PlayerModal
